// MENU.JS
console.log("menu loaded");
document.addEventListener("DOMContentLoaded", function () {
  // MENU ANIMATION & GRADIENT LOGIC (COMBINED)
  const menuWrapper = document.querySelector(".menu-section-wrapper");
  const menuGradient = document.querySelector(".menu-gradient");
  const menuElement = document.getElementById("menu");
  const menuContentWrapper = document.querySelector(".menu-content-wrapper");
  const menuFooter = document.getElementById("menu-footer");
  const btn = document.getElementById("menu-toggle");
  const bodyblock = document.getElementById("body-block");
  const cartContainer = document.querySelector(".cart-container");
  const cartWrapper = document.getElementById("cart-container-wrapper");
  const menuSections = document.querySelectorAll(".menu-section-wrapper");
  const returnToMenuBtn = document.getElementById("return-to-menu");
  const menuSVG = document.querySelector(".CL_MENU");
  const closeSVG = document.querySelector(".menu-close");

  // Set initial state - everything starts with opacity 0
  if (menuElement) {
    menuElement.style.opacity = "0";
    menuElement.style.transition = "opacity 0.5s ease-out";
  }
  if (menuContentWrapper) {
    menuContentWrapper.style.opacity = "0";
    menuContentWrapper.style.transition = "opacity 0.5s ease-out";
  }
  if (menuGradient) {
    menuGradient.style.opacity = "0";
    menuGradient.style.transition = "opacity 0.5s ease-out";
  }
  if (menuFooter) {
    menuFooter.style.opacity = "0";
    menuFooter.style.transition = "opacity 0.5s ease-out";
  }

  function isMenuVisible() {
    return (
      menuElement && window.getComputedStyle(menuElement).display !== "none"
    );
  }
  function isMenuScrollable() {
    if (!isMenuVisible() || !menuWrapper) return false;
    void menuWrapper.offsetHeight;
    return menuWrapper.scrollHeight > menuWrapper.clientHeight;
  }
  function updateGradientOpacity() {
    if (!menuGradient || !menuWrapper || !isMenuVisible()) return;
    const isScrollable = menuWrapper.scrollHeight > menuWrapper.clientHeight;
    if (isScrollable) {
      menuGradient.style.transition = "";
      const scrollMax = menuWrapper.scrollHeight - menuWrapper.clientHeight;
      const scrollPercent =
        scrollMax > 0 ? menuWrapper.scrollTop / scrollMax : 0;
      const opacity = Math.max(0, 1 - scrollPercent);
      menuGradient.style.opacity = opacity.toString();
    } else {
      menuGradient.style.opacity = "0";
    }
  }
  function fadeInMenuContainer() {
    if (menuElement) {
      menuElement.style.opacity = "1";
    }
    if (menuGradient) {
      menuGradient.style.transition = "opacity 0.3s ease-out";
      menuGradient.style.opacity = window.menuNeedsGradient ? "1" : "0";
    }
  }
  function fadeInMenuContents() {
    if (menuContentWrapper) menuContentWrapper.style.opacity = "1";
    if (menuFooter) menuFooter.style.opacity = "1";
  }
  function hideMenuContainer() {
    if (menuElement) menuElement.style.opacity = "0";
    if (menuGradient) menuGradient.style.opacity = "0";
  }
  function hideMenuContents() {
    if (menuContentWrapper) menuContentWrapper.style.opacity = "0";
    if (menuFooter) menuFooter.style.opacity = "0";
  }
  function initializeMenuGradient(options = {}) {
    if (!isMenuVisible() || !menuWrapper) return false;
    void menuWrapper.offsetHeight;
    const isScrollable = menuWrapper.scrollHeight > menuWrapper.clientHeight;
    if (menuGradient) {
      if (options.withTransition !== false) {
        menuGradient.style.transition = "opacity 0.3s ease-out";
      }
      menuGradient.style.opacity = isScrollable ? "1" : "0";
    }
    return isScrollable;
  }
  if (menuWrapper) {
    menuWrapper.addEventListener("scroll", updateGradientOpacity, {
      passive: true,
    });
  }
  window.addEventListener("resize", function () {
    if (isMenuVisible()) {
      const needsGradient = isMenuScrollable();
      window.menuNeedsGradient = needsGradient;
      if (menuGradient) {
        menuGradient.style.opacity = needsGradient ? "1" : "0";
      }
    }
  });
  window.fadeInMenuContainer = fadeInMenuContainer;
  window.fadeInMenuContents = fadeInMenuContents;
  window.hideMenuContainer = hideMenuContainer;
  window.hideMenuContents = hideMenuContents;
  window.initializeMenuGradient = initializeMenuGradient;
  if (isMenuVisible()) {
    initializeMenuGradient();
    fadeInMenuContainer();
    setTimeout(fadeInMenuContents, 50);
  }

  var modal = document.getElementById("menu");

  function toggleCart() {
    // First, fade out menu sections
    menuSections.forEach((section) => {
      section.style.transition = "opacity 0.3s ease-out";
      section.style.opacity = "0";
    });

    // Wait for menu sections to fade out before showing cart
    setTimeout(function () {
      // IMPORTANT: Reset menu scroll positions FIRST
      menuSections.forEach((section) => {
        section.scrollTop = 0;
        section.style.display = "none";
        section.style.opacity = "1";
      });

      // Handle menu gradient
      const menuGradient = document.querySelector(".menu-gradient");
      if (menuGradient) {
        menuGradient.style.transition = "opacity 0.3s ease-out";
        menuGradient.style.opacity = "0";

        setTimeout(function () {
          menuGradient.style.display = "none";
        }, 300);
      }

      // Set up cart with initial opacity 0
      cartWrapper.style.opacity = "0";
      cartWrapper.style.display = "flex";
      cartWrapper.style.transition = "opacity 0.3s ease-out";

      // Show return button, hide cart container
      cartContainer.style.display = "none";
      returnToMenuBtn.style.display = "flex";

      // Reset cart scroll position
      const dynamicCartItems = document.getElementById("dynamic-cart-items");
      if (dynamicCartItems) {
        dynamicCartItems.scrollTop = 0;
      }

      // Force layout recalculation
      void cartWrapper.offsetHeight;

      // Fade in the cart
      cartWrapper.style.opacity = "1";
    }, 300);
  }
  // Also update returnToMenu function for a smooth transition back
  function returnToMenu() {
    // First fade out the cart
    cartWrapper.style.opacity = "0";

    // Wait for cart to fade out before showing menu sections
    setTimeout(function () {
      // Hide cart after it's faded out
      cartWrapper.style.display = "none";

      const menuGradient = document.querySelector(".menu-gradient");
      if (menuGradient) {
        // First make it visible but with opacity 0
        menuGradient.style.display = "block";
        menuGradient.style.opacity = "0";

        // Force layout calculation to ensure transitions work
        void menuGradient.offsetHeight;

        // Add proper transition again
        menuGradient.style.transition = "opacity 0.3s ease-out";
      }

      // Important: Scroll all menu sections to the top BEFORE they're visible
      menuSections.forEach((section) => {
        section.scrollTop = 0;
      });

      // Show menu sections with opacity 0 initially
      menuSections.forEach((section) => {
        section.style.opacity = "0";
        section.style.display = "flex";
        section.style.transition = "opacity 0.3s ease-out";
      });

      // Show cart container, hide return button
      cartContainer.style.display = "flex";
      returnToMenuBtn.style.display = "none";

      // Trigger reflow
      menuSections.forEach((section) => void section.offsetHeight);

      // Fade in menu sections
      menuSections.forEach((section) => {
        section.style.opacity = "1";
      });

      // If we have the global initialize function for menu gradient, call it
      setTimeout(function () {
        if (typeof window.initializeMenuGradient === "function") {
          window.initializeMenuGradient();
        }
      }, 350);
    }, 300); // ADD THIS CLOSING PARENTHESIS AND CURLY BRACE
  } // ADD THIS CLOSING CURLY BRACE

  function closeModal() {
    // Hide both the contents and container simultaneously
    if (typeof window.hideMenuContents === "function") {
      window.hideMenuContents();
    }

    if (typeof window.hideMenuContainer === "function") {
      window.hideMenuContainer(); // Remove the delay - fire immediately
    }

    resetAllExpandedCategories();

    // The final cleanup still happens after the animation completes
    setTimeout(function () {
      modal.style.display = "none";
      btn.classList.remove("toggled");
      cartWrapper.style.display = "none";
      cartContainer.style.display = "flex";
      returnToMenuBtn.style.display = "none";
      menuSections.forEach((section) => (section.style.display = "flex"));
      document.body.style.overflow = "auto";
      bodyblock.style.display = "none";

      if (closeSVG.style.display === "block") {
        menuSVG.style.display = "block";
        closeSVG.style.display = "none";
      }
    }, 400);
  }

  // Menu reset on re-open
  function resetAllExpandedCategories() {
    const expandedCategories = document.querySelectorAll(
      ".category-wrapper.expanded"
    );
    expandedCategories.forEach((wrapper) => {
      // Remove expanded class
      wrapper.classList.remove("expanded");

      // Call the existing reset function from SCRIPT-MENU-CATEGORY.JS
      if (typeof resetCategoryAnimation === "function") {
        resetCategoryAnimation(wrapper);
      } else {
        // Fallback if the function isn't directly accessible
        // Reset title container position
        const titleContainer = wrapper.querySelector(
          ".category-title-container"
        );
        if (titleContainer) {
          titleContainer.style.transform = "translateX(0)";
          titleContainer.style.removeProperty("right");
        }

        // Hide all items and reset their state
        const items = wrapper.querySelectorAll(".category-item");
        items.forEach((item) => {
          item.classList.remove("visible");
          item.style.removeProperty("opacity");
        });

        // Hide and reset all submenu items
        const menuLists = wrapper.querySelectorAll(".menu-list-items");
        menuLists.forEach((menu) => {
          menu.style.display = "none";

          const subItems = menu.querySelectorAll(".category-item");
          subItems.forEach((item) => {
            item.classList.remove("visible");
            item.style.removeProperty("opacity");
          });
        });

        // Reset plus/minus icons
        const submenuExpands = wrapper.querySelectorAll(
          ".submenu-expand-container"
        );
        submenuExpands.forEach((container) => {
          const plus = container.querySelector(".submenu-expand-plus");
          const minus = container.querySelector(".submenu-expand-minus");
          if (plus) plus.style.display = "block";
          if (minus) minus.style.display = "none";
        });

        // Plus/minus for main category
        const mainPlus = wrapper.querySelector(".menu-expand-plus");
        const mainMinus = wrapper.querySelector(".menu-expand-minus");
        if (mainPlus) mainPlus.style.display = "block";
        if (mainMinus) mainMinus.style.display = "none";
      }
    });
  }

  function expandCategoryWithActiveLink() {
    // Find any active menu items
    const activeLinks = document.querySelectorAll(
      ".category-item.active, .subcategory-item.active"
    );

    // For each active link
    activeLinks.forEach((activeLink) => {
      // Find its parent category
      const categoryWrapper = activeLink.closest(".category-wrapper");
      if (categoryWrapper) {
        // Expand the category if not already expanded
        if (!categoryWrapper.classList.contains("expanded")) {
          const headerContainer = categoryWrapper.querySelector(
            ".category-header-container"
          );
          if (headerContainer) {
            // Programmatically trigger a click event on the header
            headerContainer.click();
          }
        }

        // If it's a submenu item, also expand the submenu
        if (activeLink.classList.contains("subcategory-item")) {
          const menuListItems = activeLink.closest(".menu-list-items");
          if (menuListItems) {
            const submenuHeader = menuListItems.previousElementSibling;
            if (
              submenuHeader &&
              submenuHeader.classList.contains("submenu-header-container")
            ) {
              // Check if submenu is not already visible
              if (window.getComputedStyle(menuListItems).display === "none") {
                submenuHeader.click();
              }
            }
          }
        }
      }
    });
  }

  // MENU BUTTON TOGGLE
  btn.onclick = function () {
    const msg = document.querySelector(".index-message-wrapper");
    if (modal.style.display === "none" || modal.style.display === "") {
      // Animate message background to transparent
      if (msg) msg.style.backgroundColor = "rgba(0,0,0,0)";

      // First hide both container and contents to start fresh
      if (typeof window.hideMenuContainer === "function") {
        window.hideMenuContainer();
      }
      if (typeof window.hideMenuContents === "function") {
        window.hideMenuContents();
      }

      // Make menu visible but with opacity 0
      modal.style.display = "block";
      btn.classList.add("toggled");
      document.body.style.overflow = "hidden";
      bodyblock.style.display = "block";

      // Reset scroll position of all menu sections
      menuSections.forEach((section) => {
        section.scrollTop = 0;
      });

      if (typeof window.fadeInMenuContents === "function") {
        setTimeout(function () {
          window.fadeInMenuContents();

          // Add this: Auto-expand the category with active link
          setTimeout(function () {
            expandCategoryWithActiveLink();
          }, 400); // Wait for menu animations to complete
        }, 350); // Wait ~300ms for container animation + buffer
      }

      // Calculate if gradient is needed while everything is hidden
      if (typeof window.calculateGradientNeeds === "function") {
        window.calculateGradientNeeds();
      }

      // First animation: fade in just the container
      if (typeof window.fadeInMenuContainer === "function") {
        setTimeout(function () {
          window.fadeInMenuContainer();
        }, 10); // Small delay to ensure display block is processed
      }

      // Second animation: fade in the contents after container is visible
      if (typeof window.fadeInMenuContents === "function") {
        setTimeout(function () {
          window.fadeInMenuContents();
        }, 350); // Wait ~300ms for container animation + buffer
      }
    } else {
      // Restore message background color
      const msg = document.querySelector(".index-message-wrapper");
      if (msg) msg.style.backgroundColor = "rgba(0,0,0,0.5)";
      closeModal();
    }
  };

  // CLICK OUTSIDE TO CLOSE
  window.addEventListener("click", function (event) {
    if (
      modal.style.display === "block" &&
      !modal.contains(event.target) &&
      event.target !== btn
    ) {
      closeModal();
    }
  });

  // Add event listener for cart-container
  if (cartContainer) {
    cartContainer.addEventListener("click", function () {
      // First reset scroll position - do this before animation starts
      const dynamicCartItems = document.getElementById("dynamic-cart-items");
      if (dynamicCartItems) {
        dynamicCartItems.scrollTop = 0;
      }

      // Then toggle cart
      toggleCart();

      // Initialize cart gradient after animation completes
      setTimeout(function () {
        if (typeof window.initializeCartGradient === "function") {
          window.initializeCartGradient();
        }
      }, 350);
    });
  }

  // Add event listener for return-to-menu button
  if (returnToMenuBtn) {
    returnToMenuBtn.addEventListener("click", function () {
      // First scroll all menu sections to the top - do this before animation
      menuSections.forEach((section) => {
        section.scrollTop = 0;
      });

      // Then return to menu
      returnToMenu();
    });
  }
});

// Sold-out handling has been moved to script-cart.js

console.log("counter loaded");
function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      const cartCountElement = document.querySelector(".cart-count-container");
      if (cartCountElement) {
        cartCountElement.textContent = data.item_count;
      }
    })
    .catch((error) => console.error("Error fetching cart data:", error));
}
document.addEventListener("DOMContentLoaded", updateCartCount);

console.log("animation loaded");
function handleImageLoad(event) {
  const img = event.target;
  const loadingPlaceholder = img
    .closest(".img-and-loading-container")
    .querySelector(".image-loading");

  // Hide the loading placeholder when the image loads
  loadingPlaceholder.style.display = "none"; // Hide loading animation
  img.style.display = "block"; // Show the loaded image
}

function handleImageError(event) {
  const img = event.target;
  const loadingPlaceholder = img
    .closest(".img-and-loading-container")
    .querySelector(".image-loading");

  // Hide the loading placeholder if the image fails to load
  loadingPlaceholder.style.display = "none"; // Hide loading animation
  img.style.display = "none"; // Hide the image
}

function initializeImageLoading() {
  // Select all images in the product grid and product page (including newly loaded ones)
  const productImages = document.querySelectorAll(
    ".product-grid-image, .product-page-image"
  );

  // Add load and error event listeners to each image
  productImages.forEach((image) => {
    // Initially hide the image and show the loading placeholder
    image.style.display = "none"; // Initially hide the image

    // Show loading placeholder (should already be visible)
    const loadingPlaceholder = image
      .closest(".img-and-loading-container")
      .querySelector(".image-loading");
    loadingPlaceholder.style.display = "flex"; // Ensure loading animation is visible

    image.addEventListener("load", handleImageLoad); // Load event
    image.addEventListener("error", handleImageError); // Error event

    // Force image loading for correct loading animation behavior
    image.src = image.src; // Reassign src to trigger loading
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeImageLoading();
});

console.log("reset loaded");
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    // Detect if page is loaded from cache (back button)
    // Select the element that had the hover effect
    let hoveredElement = document.querySelector(".product-grid-image");
    if (hoveredElement) {
      // Reset the hover styles by removing the class or resetting inline styles
      hoveredElement.classList.remove("hovered-class");
      hoveredElement.style.opacity = ""; // Reset any inline styles
    }
  }
});

console.log("ln captured");
// Immediately change the body style to black
document.body.style.backgroundColor = "black";

// Check the user's language and navigate to /en if it's English
if (
  navigator.language.startsWith("en") &&
  !window.location.pathname.startsWith("/en")
) {
  window.location.replace("/en");
}
